import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  createGlobalAccountTitle: 'Create your global account in:',
  creatingGlobalAccountTitle: 'Creating a global account in {{currencyName}}',
  accountCreatedTitle: 'All set! Account created',
  accountCreatedSubtitle:
    'You can now view your {{currencyName}} account on the dashboard',
  configureEnterpriseAccount: 'Start using your new business account',
  addFundsDetails:
    'Receive international and local payments or add funds to your business account in {{currencyName}}.',
  convertTitle: 'Convert',
  convertDetails: 'You can convert any of your currencies to {{currencyName}}.',
  cancelButton: 'Cancel',
  createButton: 'Create',
  tryAgainButton: 'Try again',
  creatingGlobalAccountErrorTitle: 'Something went wrong',
  creatingGlobalAccountErrorDescription:
    'Please, try again or <0>contact us.</0>',
  intercomErrorCreatingWallet:
    "I can't create my global account in {{currency}}",
  tutorialTitle: 'New',
  tutorialDescription:
    'Create your new global business account here instantly in Euro or Pound Sterling.',
  tutorialButton: 'Skip',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const NEW_WALLET_MODAL_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    createGlobalAccountTitle: 'Crea tu cuenta global en:',
    creatingGlobalAccountTitle: 'Creando cuenta global en {{currencyName}}',
    accountCreatedTitle: '¡Listo! cuenta creada',
    accountCreatedSubtitle:
      'Ya puedes visualizar tu cuenta de {{currencyName}} en el dashboard',
    configureEnterpriseAccount: 'Comienza a usar tu nueva cuenta empresarial',
    addFundsDetails:
      'Recibe pagos locales e internaciones o agrega fondos a tu cuenta empresarial en {{currencyName}}.',
    convertTitle: 'Convertir',
    convertDetails:
      'Puedes convertir cualquiera de tus divisas a {{currencyName}}.',
    cancelButton: 'Cancelar',
    createButton: 'Crear',
    tryAgainButton: 'Intentar de nuevo',
    creatingGlobalAccountErrorTitle: 'Algo salió mal',
    creatingGlobalAccountErrorDescription:
      'Por favor, intenta de nuevo o <0>contáctanos</0>',
    intercomErrorCreatingWallet:
      'No puedo crear mi cuenta global en {{currency}}',
    tutorialTitle: 'Nuevo',
    tutorialDescription:
      'Crea aquí tu nueva cuenta global empresarial de forma inmediata en euros o libra esterlina.',
    tutorialButton: 'Omitir',
  },
};

export default NEW_WALLET_MODAL_LABELS;
